import { render } from "./EditCountryTable.vue?vue&type=template&id=9961bf14&scoped=true"
const script = {}

import "./EditCountryTable.vue?vue&type=style&index=0&id=9961bf14&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9961bf14"]])

export default __exports__